goog.provide('el8.tourguide.onboardHome');

goog.require('el8.tourguide.util');
goog.require('el8.tourguide.homeInfoSplash');
goog.require('el8.tourguide.homeSuggestChart');


el8.tourguide.onboardHome.init = function() {

    el8.tourguide.util.manageSplash({
        startBtnFn: function() { return 'Continue'; },
        startTriggerFn: function() {
            el8.tourguide.homeInfoSplash.show(function() {
                el8.tourguide.homeSuggestChart.show();
            });
        }
    });

};



